import type { Responsive } from '../types'

export const ResponsiveText = ({ value }: { value: Responsive<string> }) =>
  typeof value === 'string' ? (
    <>{value}</>
  ) : (
    <>
      <span className='lg:hidden'>{value.mobile}</span>
      <span className='hidden lg:inline'>{value.desktop}</span>
    </>
  )
